module.exports = __webpack_public_path__ + "img/guozai_01.cc66d592.jpg";